// Plaqueros accessory: spray can.
// Silhouette = cylinder + cap + visible nozzle + tag flick line.
// The flick line is the cultural cue — it's not a still can, it's mid-tag.

interface SpraycanProps {
  /** Primary fill (can body). Defaults to chrome. */
  bodyColor?: string;
  /** Accent fill (cap + flick line). Defaults to candy purple. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function Spraycan({
  bodyColor = '#c0c4ca',
  accentColor = '#6b2d8c',
  size = 48,
  className,
}: SpraycanProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Cap — angled top */}
      <path d="M16 6 L30 6 L30 12 L16 12 Z" fill={accentColor} />
      {/* Nozzle */}
      <rect x="21" y="2" width="4" height="5" fill={accentColor} />
      {/* Can body — chrome cylinder with subtle gradient */}
      <rect x="14" y="12" width="18" height="28" rx="1" fill={bodyColor} />
      {/* Highlight stripe — left edge */}
      <rect x="14" y="12" width="2" height="28" fill="rgba(255,255,255,0.25)" />
      {/* Shadow stripe — right edge */}
      <rect x="30" y="12" width="2" height="28" fill="rgba(0,0,0,0.2)" />
      {/* Label band — mid-can */}
      <rect x="14" y="22" width="18" height="6" fill={accentColor} fillOpacity="0.7" />
      {/* The tag flick — arc of paint coming out the nozzle */}
      <path
        d="M25 4 Q34 0 40 6 Q42 10 38 14"
        stroke={accentColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.85"
      />
      {/* Tag drop — single drip below the arc */}
      <circle cx="40" cy="16" r="1.5" fill={accentColor} opacity="0.7" />
    </svg>
  );
}
